export default __webpack_public_path__ + "static/media/175.8f883080.png";